export default __webpack_public_path__ + "static/media/expense_bg_right.e4f644ef.png";